export const getSetupItems = (guideTutorials, systemOptions, moduleSelections, moduleSelectionsTwo, that) => {
    const completedTutorials = guideTutorials.reduce((acc, tutorial) => {
        acc[tutorial.tutorialKey] = tutorial.isCompleted;
        return acc;
    }, {});
    return [
        {
            key: "aiChatbot",
            title: that.$t("setupWizard.aiChatbot.title"),
            description: that.$t("setupWizard.aiChatbot.content"),
            routerUrl: "chatbot",
            completed: false,
            isEnabled: systemOptions?.aiChatbot,
        },
        {
            key: "aiAssistant",
            title: that.$t("setupWizard.aiAssistant.title"),
            description: that.$t("setupWizard.aiAssistant.content"),
            routerUrl: "integrations/openai",
            completed: false,
            isEnabled: systemOptions?.aiAssistant,
        },
        {
            key: "aiLiveSupport",
            title: that.$t("setupWizard.aiLiveSupport.title"),
            description: that.$t("setupWizard.aiLiveSupport.content"),
            routerUrl: "chat",
            completed: false,
            isEnabled: systemOptions?.aiLiveSupport,
        },
        {
            key: "aiAutomation",
            title: that.$t("setupWizard.aiAutomation.title"),
            description: that.$t("setupWizard.aiAutomation.content"),
            routerUrl: "automations",
            completed: false,
            isEnabled: systemOptions?.aiAutomation,
        },
        {
            key: "aiDynamicCrm",
            title: that.$t("setupWizard.aiDynamicCrm.title"),
            description: that.$t("setupWizard.aiDynamicCrm.content"),
            routerUrl: "visitors",
            completed: false,
            isEnabled: systemOptions?.aiDynamicCrm,
        },
        {
            key: "whatsappBusiness",
            title: that.$t("setupWizard.whatsappBusiness.title"),
            description: that.$t("setupWizard.whatsappBusiness.content"),
            routerUrl: "integrations/whatsapp-business-api",
            completed: false,
            isEnabled: moduleSelections?.whatsappBusiness,
        },
        {
            key: "whatsappWeb",
            title: that.$t("setupWizard.whatsappWeb.title"),
            description: that.$t("setupWizard.whatsappWeb.content"),
            routerUrl: "integrations/whatsapp-v2",
            completed: false,
            isEnabled: moduleSelections?.whatsappWeb,
        },
        {
            key: "instagram",
            title: that.$t("setupWizard.instagram.title"),
            description: that.$t("setupWizard.instagram.content"),
            routerUrl: "integrations/instagram",
            completed: false,
            isEnabled: moduleSelections?.instagram,
        },
        {
            key: "facebook",
            title: that.$t("setupWizard.facebook.title"),
            description: that.$t("setupWizard.facebook.content"),
            routerUrl: "integrations/messenger",
            completed: false,
            isEnabled: moduleSelections?.facebook,
        },
        {
            key: "telegram",
            title: that.$t("setupWizard.telegram.title"),
            description: that.$t("setupWizard.telegram.content"),
            routerUrl: "integrations/telegram-qr",
            completed: false,
            isEnabled: moduleSelections?.telegram,
        },
        {
            key: "mail",
            title: that.$t("setupWizard.mail.title"),
            description: that.$t("setupWizard.mail.content"),
            routerUrl: "mails",
            completed: false,
            isEnabled: moduleSelections?.mail,
        },
        // {
        //     key: "webChat",
        //     title: "Web Chat",
        //     description: "Web sitenize canlı destek widget'ını ekleyin.",
        //     routerUrl: "chat",
        //     completed: false,
        //     isEnabled: moduleSelections?.webChat,
        //     goToSetup: false,
        // },
        // {
        //     key: "ai",
        //     title: "Yapay Zeka",
        //     description: "Supsis AI altyapısını genel ayarlarıyla yapılandırın.",
        //     routerUrl: "chat",
        //     completed: false,
        //     isEnabled: moduleSelections?.ai,
        //     goToSetup: false,
        // },
        {
            key: "metaLead",
            title: that.$t("setupWizard.metaLead.title"),
            description: that.$t("setupWizard.metaLead.content"),
            routerUrl: "integrations/meta-leads",
            completed: false,
            isEnabled: moduleSelections?.metaLead,
        },
        {
            key: "trendyol",
            title: that.$t("setupWizard.trendyol.title"),
            description: that.$t("setupWizard.trendyol.content"),
            routerUrl: "integrations/trendyol",
            completed: false,
            isEnabled: moduleSelections?.trendyol,
        },
        {
            key: "formSurvey",
            title: that.$t("setupWizard.formSurvey.title"),
            description: that.$t("setupWizard.formSurvey.content"),
            routerUrl: "form",
            completed: false,
            isEnabled: moduleSelectionsTwo?.formSurvey,
        },
        {
            key: "processManagement",
            title: that.$t("setupWizard.processManagement.title"),
            description: that.$t("setupWizard.processManagement.content"),
            routerUrl: "tasks",
            completed: false,
            isEnabled: moduleSelectionsTwo?.processManagement,
        },
        // {
        //     key: "videoCall",
        //     title: "Görüntülü Görüşme",
        //     description: "Supsis AI ile müşterilerinizle görüntülü iletişim kurun.",
        //     routerUrl: "chat",
        //     completed: false,
        //     isEnabled: moduleSelectionsTwo?.videoCall,
        //     goToSetup: false,
        // },
        {
            key: "calendar",
            title: that.$t("setupWizard.calendar.title"),
            description: that.$t("setupWizard.calendar.content"),
            routerUrl: "calendar",
            completed: false,
            isEnabled: moduleSelectionsTwo?.calendar,
        },
        {
            key: "websiteAnalysis",
            title: that.$t("setupWizard.websiteAnalysis.title"),
            description: that.$t("setupWizard.websiteAnalysis.content"),
            routerUrl: "report-new?report=website-analysis",
            completed: false,
            isEnabled: moduleSelectionsTwo?.websiteAnalysis,
        },
        // {
        //     key: "adReporting",
        //     title: "Reklam Raporlama",
        //     description: "Reklam performanslarınızı takip edin ve analiz edin.",
        //     routerUrl: "report-new?report=channel-breakdown",
        //     completed: false,
        //     isEnabled: moduleSelectionsTwo?.adReporting,
        //     goToSetup: false,
        // },
        {
            key: "ticketSystem",
            title: that.$t("setupWizard.ticketSystem.title"),
            description: that.$t("setupWizard.ticketSystem.content"),
            routerUrl: "ticket",
            completed: false,
            isEnabled: moduleSelectionsTwo?.ticketSystem,
        },
        // {
        //     key: "webPush",
        //     title: "Web Push Bildirimleri",
        //     description: "Ziyaretçilere tarayıcı üzerinden bildirim gönderin.",
        //     routerUrl: "chat",
        //     completed: false,
        //     isEnabled: moduleSelectionsTwo?.webPush,
        // },
        // {
        //     key: "remarketing",
        //     title: "Yeniden Pazarlama",
        //     description: "Sitenizi ziyaret eden kullanıcıları tekrar hedefleyin.",
        //     routerUrl: "chat",
        //     completed: completedTutorials?.remarketing,
        //     isEnabled: moduleSelectionsTwo?.remarketing,
        // },
        {
            key: "dynamicTables",
            title: that.$t("setupWizard.dynamicTables.title"),
            description: that.$t("setupWizard.dynamicTables.content"),
            routerUrl: "tables",
            completed: false,
            isEnabled: moduleSelectionsTwo?.dynamicTables,
        },
        {
            key: "aiVoice",
            title: that.$t("setupWizard.aiVoice.title"),
            description: that.$t("setupWizard.aiVoice.content"),
            routerUrl: "integrations/voice-agent",
            completed: false,
            isEnabled: moduleSelectionsTwo?.aiVoice,
        },
    ].map((item) => {
       if(completedTutorials[item.key]) item.completed = true;
       return item;
    })
};
